// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___1q-kt","title":"style__title___LXyDq","subtitle":"style__subtitle___2RdTS","inputContainer":"style__inputContainer___1WhfP","input":"style__input___2At6K","inputMessage":"style__inputMessage___2XtBH","inputPassword":"style__inputPassword___2tqA1","inputError":"style__inputError___2Jgbp","error":"style__error___xb-1C","button":"style__button___NzWyi","text":"style__text___BxveI","textBold":"style__textBold___m_kMX","backButton":"style__backButton___K15Yq"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/booster-forgot-password/style.css
// module id = 1233
// module chunks = 0